import * as React from 'react';
import getScrollbarSize from './get_scrollbar_size';
import useEffect from './use_effect';
export function getOwnerDocument(node) {
  var ssrDocument = typeof document !== 'undefined' ? document : {};
  return node && node.ownerDocument || ssrDocument;
}
function getOwnerWindow(node) {
  var document = getOwnerDocument(node);
  return 'defaultView' in document && document.defaultView || window;
}
function hasScroll(container) {
  var containerDocument = getOwnerDocument(container);
  if ('body' in containerDocument && containerDocument.body === container) {
    return getOwnerWindow(container).innerWidth > containerDocument.documentElement.clientWidth;
  }
  return container.scrollHeight > container.clientHeight;
}
/**
 * A React hook that will receive a `container` and a value `lock`
 * that will control its parent scroll lock state.
 *
 * @returns {void}
 */
export default function useLockScroll(props) {
  var {
    container,
    disableScrollLock = false,
    isRTL = false,
    lock = false
  } = props;
  var initialStyleValues = React.useRef([]);
  useEffect(() => {
    var restoreInitialValues = () => {
      initialStyleValues.current.forEach(_ref => {
        var {
          el,
          property,
          value
        } = _ref;
        if (value) {
          el.style.setProperty(property, value);
        } else {
          el.style.removeProperty(property);
        }
      });
      initialStyleValues.current = [];
    };
    if (!disableScrollLock) {
      if (lock) {
        if (hasScroll(container)) {
          var scrollbarSize = getScrollbarSize();
          var customPosition = isRTL ? 'padding-left' : 'padding-right';
          var paddingValue = isRTL ? container.style.paddingLeft : container.style.paddingRight;
          initialStyleValues.current.push({
            el: container,
            property: customPosition,
            value: paddingValue
          });
          container.style.paddingRight = "".concat(parseInt(paddingValue || '0', 10) + scrollbarSize, "px");
        }
        var parent = container.parentElement;
        var containerWindow = getOwnerWindow(container);
        var scrollContainer = (parent === null || parent === void 0 ? void 0 : parent.nodeName) === 'HTML' && containerWindow.getComputedStyle(parent).overflowY === 'scroll' ? parent : container;
        initialStyleValues.current.push({
          value: scrollContainer.style.overflow,
          property: 'overflow',
          el: scrollContainer
        });
        scrollContainer.style.overflow = 'hidden';
      } else {
        restoreInitialValues();
      }
    }
    return () => {
      restoreInitialValues();
    };
  }, [container, disableScrollLock, isRTL, lock]);
}